// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileAddTwoToneSvg from "@ant-design/icons-svg/es/asn/FileAddTwoTone";
import AntdIcon from '../components/AntdIcon';

var FileAddTwoTone = function FileAddTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileAddTwoToneSvg
  }));
};

FileAddTwoTone.displayName = 'FileAddTwoTone';
export default React.forwardRef(FileAddTwoTone);